<div class="card">

    <!-- Header -->
    <div class="flex justify-content-between align-items-center mb-4">
        <div>
            <h2 class="m-0 mb-2">Configuração de Workflows</h2>
            <p class="text-600 m-0">Gerencie as configurações dos workflows do sistema</p>
        </div>
        <p-button icon="pi pi-refresh" label="Atualizar" [outlined]="true" severity="secondary"
                  (onClick)="carregarWorkflows()"></p-button>
    </div>

    <!-- Tabela de Workflows -->
    <p-table
        [value]="workflows"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} workflows"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        [tableStyle]="{'min-width': '60rem'}">

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="entidade">
                    Entidade <p-sortIcon field="entidade"></p-sortIcon>
                </th>
                <th pSortableColumn="nome">
                    Nome <p-sortIcon field="nome"></p-sortIcon>
                </th>
                <th pSortableColumn="descricao">
                    Descrição <p-sortIcon field="descricao"></p-sortIcon>
                </th>
                <th pSortableColumn="aprovacaoAutomatica" style="width: 10rem">
                    Aprovação Automática <p-sortIcon field="aprovacaoAutomatica"></p-sortIcon>
                </th>
                <th pSortableColumn="notificaEmail" style="width: 10rem">
                    Notifica Email <p-sortIcon field="notificaEmail"></p-sortIcon>
                </th>
                <th pSortableColumn="ativo" style="width: 8rem">
                    Status <p-sortIcon field="ativo"></p-sortIcon>
                </th>
                <th style="width: 8rem">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-workflow>
            <tr>
                <td>
                    <span class="font-semibold">{{ formatarNomeEntidade(workflow.entidade) }}</span>
                </td>
                <td>{{ workflow.nome }}</td>
                <td>
                    <span class="text-overflow-ellipsis overflow-hidden white-space-nowrap"
                          style="max-width: 300px; display: inline-block;"
                          [pTooltip]="workflow.descricao"
                          tooltipPosition="top">
                        {{ workflow.descricao }}
                    </span>
                </td>
                <td class="text-center">
                    <i [class]="workflow.aprovacaoAutomatica ? 'pi pi-check text-green-500' : 'pi pi-times text-red-500'"
                       [pTooltip]="workflow.aprovacaoAutomatica ? 'Sim' : 'Não'"
                       tooltipPosition="top"></i>
                </td>
                <td class="text-center">
                    <i [class]="workflow.notificaEmail ? 'pi pi-check text-green-500' : 'pi pi-times text-red-500'"
                       [pTooltip]="workflow.notificaEmail ? 'Sim' : 'Não'"
                       tooltipPosition="top"></i>
                </td>
                <td>
                    <p-tag [value]="workflow.ativo ? 'Ativo' : 'Inativo'"
                           [severity]="workflow.ativo ? 'success' : 'danger'">
                    </p-tag>
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button
                            icon="pi pi-pencil"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            (onClick)="editarWorkflow(workflow)"
                            pTooltip="Configurar"
                            tooltipPosition="top">
                        </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-5">
                    <div class="flex flex-column align-items-center gap-3">
                        <i class="pi pi-inbox text-6xl text-400"></i>
                        <p class="text-xl text-600 m-0">Nenhum workflow encontrado</p>
                        <p class="text-500 m-0">Não há workflows configurados no sistema</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
